import BaseMenu from './BaseMenu';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import UITextComponent from '../../../Component/UI/Text';
import Game from '../../../Game';
import Renderable from '../../../Component/Renderable';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { applyDefaultButtonAnimation } from '../UIHelper';

const BTN_CLOSE = 'main_container/close_button';
const BTN_OK = 'main_container/ok_button';
const TEXT_OK = 'main_container/ok_button/ok_text';
const TEXT_TITLE = 'main_container/title_text';
const TEXT_GOT_COINS = 'main_container/coins_text';

export default class ReceiveCoinsFriendMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('receiveCoinsFriendMenu', uiSystem);
    }

    protected onShow(params: any): void {
        const textTitle = this.element.find(TEXT_TITLE);
        const textTitleComponent = textTitle.getComponent(UITextComponent);

        const textCoins = this.element.find(TEXT_GOT_COINS);
        const textCoinsComponent = textCoins.getComponent(UITextComponent);
        const textCoinsRendereable = textCoins.getComponent(Renderable);

        if (params.title) {
            textTitleComponent.text = params.title;
        } else {
            textTitleComponent.text = Game.locale.getText('ReceivedCoins');
        }

        if (params.coins) {
            textCoinsRendereable.visible = true;
            textCoinsComponent.text = Game.locale
                .getText('GotXCoins')
                .replace('[x]', params.coins);
        } else {
            textCoinsRendereable.visible = false;
        }
    }

    protected onCreate(): void {
        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        const btnOK = this.element.find(BTN_OK);
        btnOK.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnOK, AUDIO_UI_BUTTON_DEFAULT);

        const btnOKText = this.element.find(TEXT_OK);
        btnOKText.getComponent(UITextComponent).text = 'OK';
    }
}
